export const themeOptions = [
  { value: 'default', label: 'Use System Default' },
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' }
];
